import React from "react";

export default function InputLinkedin({ errors, register }) {
  return (
    <input
      className={`form-control ${errors.linkedin_url && "is-invalid"}`}
      type="text"
      placeholder="https://linkedin.com/in/12usuario"
      name="linkedin_url"
      {...register("linkedin_url", {
        pattern: {
          value: /^https:\/\/(www\.)?linkedin\.com\/(in\/)?[a-zA-Z0-9._-]+\/?$/,
          message:
            "La URL debe comenzar con https://linkedin.com/ y contener un usuario",
        },
      })}
    />
  );
}
